import {createSelector} from 'reselect';
import {accountNumber as linkedAccountNumber} from 'src/shared/extendedProfile/selectors';
import {accountNumber as userAccountNumber} from 'src/shared/user/selectors';

export const accountNumber = createSelector(
  [linkedAccountNumber, userAccountNumber],
  (linkedAccountNumber, userAccountNumber) => linkedAccountNumber || userAccountNumber
);

